module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('GeoImp', {
    staticClass: "contentWrapper",
    attrs: {
      "checkDate": _vm.checkDate,
      "clickDate": _vm.clickDate,
      "clearSelectedDate": _vm.clearSelectedDate,
      "viewData": _vm.viewData.data
    }
  }), _vm._v(" "), _c('dateTable', {
    attrs: {
      "checkDate": _vm.checkDate,
      "clickDate": _vm.clickDate,
      "campaginDaysData": _vm.viewData.daysData,
      "dataInfo": _vm.viewData.data,
      "tab": "geo"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53ed84a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign/geo/GeoMain.vue
// module id = 849
// module chunks = 1